const pulseTriviTnC = {
  header: "MTN Pulse Trivia (Digital) Terms and Conditions",
  body: [
    {
      title: "INTRODUCTION",
      details: `The MTN Pulse Trivia (Trivia) is a digital based activity for MTN Pulse. Trivia is intended to create hype and offer an exclusive experience for the Millennials and Gen-Zs using myMTN App to increase active users and reward loyal users. Eligible Trivia winners shall be given access to the rewards feature on the app to select a preferred reward or prize.
      `,
    },
    {
      title: `ELIGIBILITY`,
      details: `1. To be eligible for participation and claim a prize, each participant must be between the age of fifteen (15) and thirty-five (35) years.`,
    },
    {
      title: ``,
      details: `2. Participant(s) must have a smartphone to participate in Trivia.`,
    },
    {
      title: ``,
      details: `3. Participants must have a valid Ghana card.`,
    },
    {
      title: ``,
      details: `4. There will be no opt-in by way of Unstructured Supplementary Service Data (USSD) channel to participate in the trivia.`,
    },
    {
      title: ``,
      details: `5. Sim cards dedicated solely for commercial transactions by MTN Mobile Money agents and MTN Mobile Money merchants and the owners of the SIMS are NOT eligible for Trivia.`,
    },
    {
      title: ``,
      details: `6. MTN staff and their spouses as well as third party agents of MTN are excluded from participation of this Trivia.`,
    },
    {
      title: `TERMS`,
      details: `7. Trivia can be played on Trivia Tuesday, during Festivals and at during special events to be communicated on the platform by MTN.`,
    },
    {
      title: ``,
      details: `8. Eligible participants must play the trivia at specified locations and within stipulated time frame.`,
    },
    {
      title: ``,
      details: `9. Eligible participants must answer ALL questions correctly to stand a chance of winning a prize/reward.`,
    },
    {
      title: ``,
      details: `10. Eligible participants shall have multiple chances to answer the Trivia. The number of attempts shall be based on the trivia type.`,
    },
    {
      title: ``,
      details: `11. Eligible participants will receive an in-app notification or will be granted access to the rewards tab to select a preferred reward (applicable to voucher rewards).`,
    },
    {
      title: ``,
      details: `12. The audited selection process to determine winners is final and no correspondence will be entered into in relation to this. In the event of a dispute, MTN’s decision is final and binding.`,
    },
    {
      title: ``,
      details: `13. A reward or prize selected shall be non-transferable, cannot be exchanged for another item and cannot be redeemed for cash. Where a reward or prize is not received as a result of failure by a winner’s representative to deliver to the winner, the reward or prize shall not be replaced by MTN.`,
    },
    {
      title: ``,
      details: `14. MTN reserves the right to disqualify a winner when it is proven that the winner used fraudulent means to participate in the Trivia. Such participants will be handed over to the police for prosecution.`,
    },
    {
      title: ``,
      details: `15. MTN reserves the right to alter the Terms and Conditions at any point in time during the Trivia period and the Terms and Conditions as amended will be posted on MTN’s website.`,
    },
    {
      title: ``,
      details: `16. MTN shall not be liable where a force majeure event results in the annulment, shortening, extension or amendment of the Terms and Conditions of this Trivia.`,
    },
    {
      title: ``,
      details: `17. MTN shall not be liable to perform its obligations under this Trivia if the information provided by any winner is erroneous, incomplete or incorrect.`,
    },
    {
      title: ``,
      details: `18. Participant(s) hereby consent to MTN using and processing their personal information in accordance with the applicable data protection laws (Data Protection Act 2012, Act 843), for processing of the participant’s entry as stated in these Terms and Conditions, as well as for any marketing and promotions. The participant may contact MTN in order to have their personal information verified, amended or removed from the MTN database.`,
    },
    {
      title: ``,
      details: `19. The personal data of the participants will be retained by MTN in accordance with the Data Protection Act, 2012 Act 843 and shall only be shared with approved parties.`,
    },
    {
      title: ``,
      details: `20. Prizes to be won may be airtime, data bundles, gift vouchers from partner shops such as Melcom, Shoprite, KFC and other parties MTN may partner with for Trivia.`,
    },
    {
      title: ``,
      details: `21. Winners shall be notified only by MTN authorized personnel and via the number 0244 300 000 ONLY.`,
    },
    {
      title: `DISCLAIMER`,
      details: `MTN reserves the right, in its sole discretion, to modify or replace these Terms and Conditions at any time. If a revision is material, at least three (3) days' notice will be given prior to any new provisions taking effect. What constitutes a material change will be determined by MTN.`,
    },
    {
      title: `CHANGES`,
      details: `GHS 30 Airtime`,
    },
    {
      title: `APPLICABLE LAW AND JURISDICTION`,
      details: `The applicable law of these Terms and Conditions shall be the laws of Ghana and the courts of Ghana shall have jurisdiction in any matter(s) arising herein.`,
    },
    {
      title: `BUSINESS ADDRESS`,
      details: `Location: MTN House, Independence Avenue,`,
    },

    {
      title: ``,
      details: `West Ridge, Accra Ghana`,
    },
    {
      title: ``,
      details: `Division: Marketing`,
    },
    {
      title: ``,
      details: `Mobile: 0244300000`,
    },
  ],
};

export default pulseTriviTnC;
